import { call, put, select } from 'redux-saga/effects';

import { setBillingDetails } from '../../../effects/organization';

import { callAPI, METHODS } from '../../api';
import { RESOURCES } from '../../../../helpers/constants';

export default function* getBillingDetails() {
  const organizationId = yield select((state) => state.organization.uuid);

  const { dpaApiBaseUrl } = yield select((state) => state.application.env);
  const url = `${dpaApiBaseUrl + RESOURCES.ORGA}/${organizationId}/billing`;
  try {
    const { success, error, result } = yield call(callAPI, {
      url,
      method: METHODS.GET,
    });

    if (success && !error) {
      // const { name, ...rest } = result
      yield put(setBillingDetails({ result, billingSuccess: true }));
    }
  } catch (e) {
    console.error(e);
  }
}
